<main class="container" style="min-height: 73vh">
  <div style="margin: auto; text-align: center;">
    <img src="assets\cvx_icon_oil-derrick_pipe-extended_RGB_FA.svg" width="200" height="200">
    <h3>Welcome {{userName}}</h3>
  </div>
</main>
